import React from 'react';


import banregio from '../../banregio.png';

/**
 * @property {Object} props
 * @property {Agente} props.currentAgent
 */
class ProfileSettings extends React.Component {
    constructor(props) {
        super(props)

        this.profileSettings= props.profileSettings;

        this.closeProfileSettings = this.closeProfileSettings.bind(this);
        this.logIn = this.logIn.bind(this);

    }

    closeProfileSettings() {
      this.profileSettings.current.style.left = "-110%";
    }

    logIn() {
        var provider = new window.firebase.auth.GoogleAuthProvider();
        // [END createprovider]
        // [START addscopes]
        provider.addScope('https://www.googleapis.com/auth/plus.login');
        // [END addscopes]
        // [START signin]
        window.firebase.auth().signInWithRedirect(provider);
    }
    renderLogInButton() {
        if (this.props.currentAgent == null) {
            return <button className="dropdown-item" onClick={this.logIn}>Iniciar sesión</button>
        } else {
            return <button className="dropdown-item">Cerrar sesión</button>
        }
    }
    render() {

      var displayName, photoURL;

      if(this.props.currentAgent == null) {
        displayName = "Sin conexión";
        photoURL    = banregio;
      } else {
        displayName = this.props.currentAgent.displayName;
        photoURL    = this.props.currentAgent.photoURL;
      }

        return (

            <div className="d-flex flex-column w-100 h-100 left-panel" ref={this.profileSettings} id="profile-settings">
                <div className="row d-flex flex-row align-items-center p-2 m-0" style={{background:"#fb6830", minHeight:"65px"}}>
                    <i className="fas fa-arrow-left p-2 mx-3 my-1 text-white" style={{fontSize: "1.5rem", cursor: "pointer"}} onClick={this.closeProfileSettings}></i>
                    <div className="text-white font-weight-bold">Perfil de agente</div>
                </div>
                <div className="d-flex flex-column" style={{overflow:"auto"}}>
                    <img alt="Profile" className="img-fluid rounded-circle my-5 justify-self-center mx-auto" id="profile-pic" src={photoURL}/>
                    <input type="file" id="profile-pic-input" className="d-none"/>
                    <div className="bg-white px-3 py-2">
                        <div className="text-muted mb-2"><label htmlFor="input-name">Tu nombre</label></div>
                        <input defaultValue={displayName} type="text" name="name" id="input-name" className="w-100 border-0 py-2 profile-input"/>
                    </div>
                    <div className="text-muted p-3 small">
                        Campaña o grupo al que pertenece.
                    </div>
                    <div className="bg-white px-3 py-2">
                        <div className="text-muted mb-2"><label htmlFor="input-about">About</label></div>
                        <input type="text" name="name" id="input-about" className="w-100 border-0 py-2 profile-input"/>
                    </div>
                </div>

            </div>
        )
    }
}

export default ProfileSettings;
